import { render, staticRenderFns } from "./incidents.vue?vue&type=template&id=554c9f98"
import script from "./incidents.vue?vue&type=script&lang=js"
export * from "./incidents.vue?vue&type=script&lang=js"
import style0 from "./incidents.vue?vue&type=style&index=0&id=554c9f98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports